import { render, staticRenderFns } from "./BulkUploadFrame.vue?vue&type=template&id=f846e63e&scoped=true"
import script from "./BulkUploadFrame.vue?vue&type=script&lang=js"
export * from "./BulkUploadFrame.vue?vue&type=script&lang=js"
import style0 from "./BulkUploadFrame.vue?vue&type=style&index=0&id=f846e63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f846e63e",
  null
  
)

export default component.exports